import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import * as action from '../store/DevelopmentOrder.action';
import * as testAction from '../../Library/Testing/Store/Testing.action';
import UploadDocumentsAssetStyle from '../../../Components/UploadDocuments/UploadDocumentsAssetStyle';
import { BombiixModal } from '../../../Components/BombiixModal';
import Loader from '../../../Components/Utility/Loader/Loader';

function UploadTesting({
  repId,
  onOpen,
  toggle,
  isRenewMode,
  documentIds,
  reportIds,
  reportDevId,
  reportStatus,
  testIds,
  renewName,
  expairyDate,
  showDropZone,
  status,
  fromTestLib,
  showData,
  fromTestReport,
}) {
  const { t } = useTranslation('common');
  const userData = useSelector((reducerState) => reducerState);
  const { UserDetails, Measuremets } = userData;
  const { testingAttributes } = Measuremets;
  const { userInfo, isSupplierLoggedIn, isProductArchived } = UserDetails;

  const loggedInUserId = userInfo.userId;
  const childRef = useRef();
  const dispatch = useDispatch();
  const ids = useParams();
  const devId = ids.devOrderId;

  const [showLoader, setShowLoader] = useState(false);
  const [testRepIds, setTestRepId] = useState([]);

  useEffect(() => {
    setTestRepId([...reportIds]);
  }, [reportIds]);

  const setStatus = (index) => {
    if (status) {
      return status[index] === 'pending' || status[index] === 'Pending' || status[index] === null || !status[index] ? 'Pending' : approveReject(index);
    }
  };

  const approveReject = (index) => {
    return status[index] === 'true' ? 'Approved' : 'Rejected';
  };

  const testingAttriWasanArray = () => {
    return !Array.isArray(testingAttributes) ? testingAttributes?._id : null;
  };

  const formatFileSize = (bytes, decimalPoint) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1000;
    const dm = decimalPoint || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
  };

  const informTest = (formData) => {
    if (fromTestLib) {
      formData.append('bomComponent', showData?.bomComponent?._id ? showData?.bomComponent?._id : null);
      formData.append('colour', showData?.colour?._id ? showData?.colour?._id : null);
      formData.append('supplier', showData?.supplier?._id ? showData?.supplier?._id : null);
      isRenewMode && formData.append('reportId', showData?.testReport?._id ? showData?.testReport?._id : null);
    }
  };

  const formDocuments = (formData, document) => {
    if (!fromTestReport) {
      formData.append('fileObj', document);
    } else if (isEmpty(reportIds)) {
      formData.append('pdf', document);
    } else {
      formData.append('fileObj', document);
      formData.append('isOldReport', true);
    }
  };

  const callToggle = async () => {
    setShowLoader(false);
    toggle();
  };

  const apiCalls = async (formData) => {
    setShowLoader(true);
    await dispatch(action.clearReducer([]));
    if (fromTestLib) {
      await dispatch(action.uploadDoc(formData, t));
      await dispatch(testAction.getAllTest({ searchText: '' }));
    } else if (fromTestReport) {
      if (isRenewMode) {
        await dispatch(action.RenewTestReportDocuments(formData, devId, t));
      } else {
        await dispatch(action.uploadTestReportDocuments(formData, devId, 'testing', t));
      }
      await dispatch(action.fetchReportList({ id: devId }));
    } else {
      await dispatch(action.postDocuments(formData, devId, t));
      await dispatch(action.ProductTesting({ id: devId }));
    }
    callToggle();
  };

  const updateExistingReport = async (submitedData) => {
    setShowLoader(true);
    const editParams = {
      devOrderId: devId,
      expire_on: submitedData?.expairyDueDate,
      pdfTitle: submitedData?.fileName,
      _id: testRepIds[0],
    };
    await dispatch(action.updateTestReports(editParams, testRepIds[0], t));

    callToggle();
  };

  const addTestReports = (testLib) => {
    if (documentIds && !isEmpty(documentIds)) {
      for (let docIndex = 0; docIndex < documentIds.length; docIndex++) {
        testLib.push({
          libId: documentIds[docIndex],
          reportId: testRepIds[docIndex] ? testRepIds[docIndex] : testingAttriWasanArray(),
          testLibId: testIds[docIndex],
          status: !fromTestLib ? setStatus(docIndex) : showData?.status,
        });
      }
    }
    if (fromTestReport) {
      testLib.push({
        libId: '',
        reportId: testRepIds[0] ? testRepIds[0] : testingAttriWasanArray(),
        testLibId: reportDevId || null,
        status: reportStatus || null,
      });
    }
  };

  const addNewDocument = async (submitedData) => {
    const formData = new FormData();
    const { document, existingAsset } = submitedData;
    formData.append('reportId', repId || testRepIds[0]);
    if (existingAsset) {
      formData.append('existingAssetId', existingAsset.id);
      formData.append('type', existingAsset.mimetype);
      formData.append('size', formatFileSize(existingAsset.size, 2));
      formData.append('name', existingAsset.fileName);
      formData.append('pdfName', existingAsset.fileName);
    } else {
      formDocuments(formData, document);
      formData.append('type', document.type);
      formData.append('size', formatFileSize(document.size, 2));
      formData.append('name', document.name);
      formData.append('pdfName', document.name);
      formData.append('isAddToAssetLibrary', submitedData.addToAssetLibrary === true);
    }

    isRenewMode && formData.append('isRenew', true);
    formData.append('changeStatus', submitedData.changeStatus);
    formData.append('pdfTitle', submitedData.fileName);
    if (submitedData.expairyDueDate) {
      if (fromTestReport) {
        formData.append('fileExpiry', moment(submitedData.expairyDueDate));
      }
      formData.append('expiredAt', moment(submitedData.expairyDueDate));
    }
    formData.append('loggedInUserId', loggedInUserId);
    informTest(formData);
    const testLib = [];
    addTestReports(testLib);
    formData.append('testLib', JSON.stringify(testLib));
    await apiCalls(formData);
  };

  const onSubmit = async () => {
    const submitedData = await childRef?.current?.selectedDocument();
    if (!submitedData) return;
    if (showDropZone) {
      await addNewDocument(submitedData);
    } else {
      await updateExistingReport(submitedData);
    }
  };

  const forRenewModefromTestReport = () => {
    return !showDropZone ? t('PARTNER_OVERVIEW.EDIT_REPORT') : t('PARTNER_OVERVIEW.UPLOAD_PDF');
  };

  return (
    <BombiixModal
      show={onOpen}
      onClose={callToggle}
      onSave={onSubmit}
      saveLabel={t('COMMON_LABEL.SAVE')}
      saveLoading={showLoader}
      title={isRenewMode ? t('PARTNER_OVERVIEW.RENEW_PDF') : forRenewModefromTestReport()}
      className="asset-style-modal-dialog"
    >
      {showLoader ? (
        <Loader />
      ) : (
        <UploadDocumentsAssetStyle
          ref={childRef}
          module="testing"
          hideName
          accept=".pdf"
          showDropZone={showDropZone}
          isRenewMode={isRenewMode}
          expairyDate={expairyDate}
          renewName={renewName}
          status={status}
          isSupplierLoggedIn={isSupplierLoggedIn}
          isProductArchived={isProductArchived}
          productId={devId}
          showAddToAssetLibrary
          onSelectedGradingGroupChange={() => {}}
          setShowGradingGroupError={() => {}}
        />
      )}
    </BombiixModal>
  );
}

export default UploadTesting;
